import { adminApiFetch } from './apiService';

export const inventoryTypeService = {
  // 列表
  fetchList: async () => {
    const response = await adminApiFetch('inventory_types');
    return response.json();
  },

  getRecords: async (params) => {
    const response = await adminApiFetch('inventory_types/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await adminApiFetch('inventory_types/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  }
};
